var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgKakaoChannelTransparent = function SvgKakaoChannelTransparent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#kakao_channel_transparent_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C3.805 0 0 3.525 0 7.871c0 3.21 1.342 4.744 3.184 6.141l.009.005v3.768c0 .178.203.28.344.173l3.223-2.396.07.03c.54.1 1.1.153 1.67.153 4.695 0 8.5-3.525 8.5-7.871C17 3.527 13.195 0 8.5 0ZM5.651 9.865c.834 0 1.546-.5 1.76-1.27h1.232c-.3 1.485-1.455 2.457-2.992 2.457-1.786 0-3.202-1.335-3.202-3.19s1.416-3.19 3.202-3.19c1.553 0 2.715.993 3.001 2.503H7.423c-.187-.821-.924-1.332-1.772-1.332-1.201 0-2 .858-2 2.019s.907 2.003 2 2.003Zm8.121 1.064h-1.13V8.378c0-.588-.341-.902-.866-.902-.587 0-.963.358-.963 1.087v2.366h-1.13V4.691h1.13v2.348c.27-.412.709-.613 1.305-.613.48 0 .876.157 1.183.48.317.325.474.764.474 1.333v2.69h-.003Z",
    fill: "#424242"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "kakao_channel_transparent_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h17v18H0z"
  })))));
};

export default SvgKakaoChannelTransparent;